import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiLoginForgotusernameMutationRequest,
  PostApiLoginForgotusernameMutationResponse,
} from "../../../types/PostApiLoginForgotusername";

export function getPostApiLoginForgotusernameUrl() {
  return `/api/Login/ForgotUsername` as const;
}

/**
 * {@link /api/Login/ForgotUsername}
 */
export async function postApiLoginForgotusername(
  data?: PostApiLoginForgotusernameMutationRequest,
  config: Partial<RequestConfig<PostApiLoginForgotusernameMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiLoginForgotusernameMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiLoginForgotusernameMutationRequest
  >({
    method: "POST",
    url: getPostApiLoginForgotusernameUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
